import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { SelectFieldResult } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class OrganisationClientTypesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getAll(): Observable<SelectFieldResult[]> {
        return this.http.get<SelectFieldResult[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/select/organisationclienttype`,
        );
    }
}
